import React from "react";
import CookiePolicy from "../Components/Other/CookiePolicy";
const Cookie = () => {
  return <CookiePolicy />;
};

export default Cookie;
